/**
 * Options de variante en cartes horizontales.
 *
 * Le thème transforme les <select> d'options en listes de boutons
 * (jQuery.clickyBoxes, theme.js). On enrichit ensuite chaque bouton pour en
 * faire une carte : format, conversion métrique, prix, étiquette « le plus
 * populaire » et phrase d'usage. Les données viennent du bloc JSON
 * data-variant-option-info posé par main-product.liquid.
 *
 * Les formats épuisés (classe .unavailable posée par theme.js) passent après
 * les formats disponibles, puis au-delà de 3 valeurs le surplus est replié
 * derrière « Plus d'options ». Sans ce tri, un format en vente pouvait finir
 * caché derrière deux formats barrés (fiches d'ail, octobre 2026).
 *
 * clickyBoxes est détruit puis reconstruit à chaque réinitialisation du
 * formulaire produit, d'où l'observateur de mutations plutôt qu'un simple
 * appel au chargement.
 */
(function () {
  'use strict';

  var MAX_VISIBLE = 3;
  var PROCESSED = 'ccOptionsCollapsed';
  var DECORATED = 'ccOptionCard';
  var SORTED = 'ccOptionsSorted';

  // Le filtre `t` de Liquid échappe le HTML : « Plus d'options » arrive donc
  // sous la forme « Plus d&#39;options ». Passer par un <textarea> décode les
  // entités sans exécuter de balise éventuelle.
  function decodeEntities(value) {
    var holder = document.createElement('textarea');
    holder.innerHTML = value;
    return holder.value;
  }

  function themeString(key, fallback) {
    var value = window.theme && theme.strings && theme.strings[key];
    return decodeEntities(value || fallback);
  }

  function moreLabel(count) {
    return themeString('moreOptions', 'More options ([[ count ]])').replace('[[ count ]]', count);
  }

  function optionInfo(list) {
    var container = list.closest ? list.closest('.option-selectors') : null;
    var script = container && container.querySelector('script[data-variant-option-info]');
    if (!script) return null;
    try {
      var map = {};
      JSON.parse(script.textContent).forEach(function (entry) {
        map[entry.value] = entry;
      });
      return map;
    } catch (e) {
      return null;
    }
  }

  function addLine(parent, className, text) {
    if (!text) return;
    var span = document.createElement('span');
    span.className = className;
    span.textContent = text;
    parent.appendChild(span);
  }

  // Ligne de prix. En solde, le prix barré suit le prix courant sur la même
  // ligne, comme dans le bloc prix de la fiche : la carte doit annoncer la
  // même remise que le prix principal, sans le répéter en dessous.
  function addPrice(parent, price, compareAt) {
    if (!price) return;
    var row = document.createElement('span');
    row.className = 'vopt__price';
    if (compareAt) row.className += ' vopt__price--sale';
    addLine(row, 'vopt__price-current', price);
    if (compareAt) {
      var was = document.createElement('s');
      was.className = 'vopt__price-was';
      was.textContent = compareAt;
      row.appendChild(was);
    }
    parent.appendChild(row);
  }

  // Compose le contenu des cartes. Renvoie le <li> de la variante populaire,
  // pour que le repli ne la masque jamais.
  function decorate(list) {
    var info = optionInfo(list);
    var popularItem = null;

    Array.prototype.forEach.call(list.querySelectorAll('a[data-value]'), function (link) {
      var data = info && info[link.getAttribute('data-value')];
      if (data && data.popular) popularItem = link.parentNode;
      if (link.dataset[DECORATED] === 'true') return;
      link.dataset[DECORATED] = 'true';

      var raw = link.textContent.trim();
      link.textContent = '';

      // Les formats du catalogue s'écrivent « 6.89 pieds x 6 pieds/2.10 m x
      // 1.83 m » : la barre oblique sépare l'impérial du métrique. Sans elle,
      // la valeur reste sur une seule ligne.
      var parts = raw.split('/');
      addLine(link, 'vopt__label', parts[0].trim());
      if (parts.length > 1) addLine(link, 'vopt__sub', parts.slice(1).join('/').trim());

      if (!data) return;
      addPrice(link, decodeEntities(data.price || ''), decodeEntities(data.compare_at_price || ''));
      if (data.popular) addLine(link, 'vopt__popular', themeString('mostPopular', 'Most popular'));
      addLine(link, 'vopt__ideal', data.ideal || '');
    });

    return popularItem;
  }

  // Déplace les formats épuisés en fin de liste, sans changer l'ordre des
  // formats disponibles entre eux. Le clic est délégué sur la liste et le
  // <select> d'origine reste intact : seul l'ordre visuel (et de tabulation)
  // change. Désactivable par le réglage du bloc (data-sold-out-last).
  function sortSoldOutLast(list) {
    if (list.dataset[SORTED] === 'true') return;
    list.dataset[SORTED] = 'true';

    var container = list.closest ? list.closest('.option-selectors') : null;
    if (!container || container.getAttribute('data-sold-out-last') !== 'true') return;

    Array.prototype.filter
      .call(list.children, function (li) {
        var link = li.tagName === 'LI' && li.querySelector('a[data-value]');
        return link && link.classList.contains('unavailable');
      })
      .forEach(function (li) {
        list.appendChild(li);
      });
  }

  function collapse(list, popularItem) {
    if (list.dataset[PROCESSED] === 'true') return;

    var items = Array.prototype.filter.call(list.children, function (li) {
      return li.tagName === 'LI' && !li.classList.contains('variant-opt-more');
    });
    if (items.length <= MAX_VISIBLE) return;

    list.dataset[PROCESSED] = 'true';

    // La recommandation ne doit jamais finir cachée dans le surplus.
    var overflow = items.slice(MAX_VISIBLE).filter(function (li) {
      return li !== popularItem;
    });
    if (!overflow.length) return;

    // Si la variante sélectionnée fait partie du surplus, on ouvre d'emblée :
    // la valeur courante ne doit jamais être masquée.
    var activeIsHidden = overflow.some(function (li) {
      var link = li.querySelector('a');
      return link && link.classList.contains('active');
    });

    var toggle = document.createElement('li');
    toggle.className = 'variant-opt-more';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'variant-opt-more__btn';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = moreLabel(overflow.length);
    toggle.appendChild(button);
    list.appendChild(toggle);

    function setExpanded(expanded) {
      overflow.forEach(function (li) {
        li.hidden = !expanded;
      });
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.hidden = expanded;
    }

    button.addEventListener('click', function () {
      setExpanded(true);
      var first = overflow[0] && overflow[0].querySelector('a');
      if (first) first.focus();
    });

    setExpanded(activeIsHidden);
  }

  function scan() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.option-selectors .clickyboxes'),
      function (list) {
        sortSoldOutLast(list);
        collapse(list, decorate(list));
      }
    );
  }

  // decorate() écrit dans le DOM observé : sans regroupement, chacune de ses
  // insertions relancerait l'observateur. Les gardes rendent ces passes
  // inoffensives, mais on les regroupe en un seul balayage par frame.
  // setTimeout plutôt que requestAnimationFrame : rAF ne s'exécute pas dans
  // un onglet d'arrière-plan, et les options ne seraient jamais composées sur
  // une page ouverte dans un onglet non actif.
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      scan();
    }, 0);
  }

  function watch() {
    scan();

    var containers = document.querySelectorAll('.option-selectors');
    if (!containers.length || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(schedule);
    Array.prototype.forEach.call(containers, function (container) {
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
